import script from "./IconCart.vue?vue&type=script&lang=ts&setup=true"
export * from "./IconCart.vue?vue&type=script&lang=ts&setup=true"

import "./IconCart.vue?vue&type=style&index=0&id=3654ddca&lang=scss"

const __exports__ = script;

export default __exports__